import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import { useEffect, useState } from 'react';

import InvoiceRow from './InvoiceRow';
import axiosInstance from '../../api/axiosInstance';

import Button from '@mui/material/Button';
import UpdateIcon from '@mui/icons-material/Update';
import { IconButton, Stack, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

function InvoicesToSendTable({accounts, invoicesToSend, handleGenerateInvoices}) {

    const handleDownloadInvoicesPDF = async () => {
        try {
            const timeframe = invoicesToSend.length > 0 ? invoicesToSend[0].date.slice(0, 7): undefined;
            console.log(timeframe);
            const request_json = {"timeframe":`${timeframe}`, "status": "to_send"};
            const response =  await axiosInstance.post(`api/invoices/download/`, request_json)
        } catch(error) {
            console.error("Erreur lors du téléchargement des factures.", error);
        }
    };

    return (
        <TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Mois facturé</TableCell>
                        <TableCell>Destinataire</TableCell>
                        <TableCell>Numéro de facture</TableCell>
                        <TableCell align="right">Montant total (€)</TableCell>
                        <TableCell align='center'>
                            {/* <Stack direction="column" spacing={1}>
                                PDFs
                                <IconButton>
                                    <FileDownloadIcon onClick={handleDownloadInvoicesPDF} fontSize="inherit" />
                                </IconButton>
                            </Stack> */}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invoicesToSend && invoicesToSend.length > 0 ? (
                        invoicesToSend.map((invoice) => (
                            <InvoiceRow key={invoice.id} invoice={invoice} accounts={accounts} />
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5} align="center">
                                <Button onClick={handleGenerateInvoices} variant="contained" endIcon={<UpdateIcon />}>
                                    Générer les factures
                                </Button>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default InvoicesToSendTable;